// app/dashboard/report.tsx
import React, { useEffect } from 'react';
import { Appbar, useTheme, Surface } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'expo-router';

export default function ReportPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const router = useRouter();
  useEffect(() => {
    router.replace({ pathname: '/dashboard/report', params: { view: 'daily' } });
  }, [router]);

  return (
    <Surface style={{ flex: 1 }}>
      <Appbar.Header style={{ backgroundColor: theme.colors.surfaceVariant }}>
        <Appbar.BackAction onPress={() => router.back()} />
        <Appbar.Content title={t('daily-report')} />
      </Appbar.Header>
    </Surface>
  );
}